import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export type PageLayoutProps = {
  className?: string;
}

export function PageLayout({ children, className }: PropsWithChildren<PageLayoutProps>) {
  return (
    <div className={classNames('pt-20', className)}>
      {children}
    </div>
  );
}
